module.exports = __webpack_public_path__ + "img/Tina.ea3fc11.png";